const meals= [
    // {
    // itemName :"Butter Chicken With Naan",
    // itemImage : "https://production-media.gousto.co.uk/cms/mood-image/1828--Creamy-Chicken-Makhani--Buttered-Naan.2.jpg",
    // itemDescription : "Butter chicken is a mild, sweet dish that pairs perfectly along with Basmati rice or naan bread. Butter chicken origin is North India. Naan is a leavened, oven - baked flatbread native to India.It resembles pita bread but unlike pita, it has yogurt, milk, sometimes eggs or butter which makes it softer than the pita bread.",

    // itemPrice :250
    // },
    // {
    //     itemName: "Veg Sanchwich",
    //     itemImage: "https://static.toiimg.com/thumb/60057435.cms?width=1200&height=900",
    //     itemDescription: "Vegetable sandwich is a type of vegetarian sandwich consisting of a vegetable filling between bread. There are no set requirements other than the use of vegetables, and sandwiches may be toasted or untoasted. ",
    //     itemPrice: 80
    // },
    {
        Item_id: "CC200ML",
        Item_name: "Cola Cola 200ml",
        IMG: "https://cdn3.mydukaan.io/app/image/700x700/?url=https://projecteagle.s3.ap-south-1.amazonaws.com/images/39115a49-3a04-474e-a4d8-ad3f97a2bafc.jpg",
        Discription: "This is Cold Drink made by Coca Cola.",
        Type: "Fast Food ",
        Item_cost : 20
    },
    {
        Item_id: "RN1L",
        Item_name: "Rail Neer 1L",
        IMG: "https://www.devdiscourse.com/remote.axd?https://devdiscourse.blob.core.windows.net/devnews/28_08_2019_22_12_14_9768113.jpg?width=920",
        Discription: "This is Mineral water made by Indian Railway.",
        Type: "Fast Food",
        Item_cost: 20
    },

    {
        Item_id: "FR500ML",
        Item_name: "Frooti Drink 500ml",
        IMG: "https://gromartt.com/wp-content/uploads/2022/10/FROOTI-500ML.jpg",
        Discription: "This is Mango juice made by Parle.",
        Type: "Fast Food ",
        Item_cost: 25
    },
    {
        Item_id: "AP",
        Item_name: "Aloo patties",
        IMG: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSf-9epUWU94MdYDrZOrAuxld1gfjNPYoc3m93-aBZqyDFbaIM6Ha82oUn0nLSvGdtbUrM&usqp=CAU",
        Discription: "Aloo patties, or Indian potato puff pastry or potato turnovers, is a vegetarian snack made with an Indian",
        Type: "Fast Food ",
        Item_cost: 20
    },
    {
        Item_id: "PP",
        Item_name: "Paneer patties",
        IMG: "https://brijwasi-images.s3.ap-south-1.amazonaws.com/snacks/1-Paneer-Patties.jpg",
        Discription: "Paneer patties, or Indian Paneer potato puff pastry or Paneer and potato turnovers, is a vegetarian snack made with an Indian",
        Type: "Fast Food ",
        Item_cost: 30
    },
    {
        Item_id: "SVT",
        Item_name: "Simple Veg Thali",
        IMG: "https://5.imimg.com/data5/IE/OY/MY-30967219/1456921564y-500x500.jpg",
        Discription: "In Indian thali comprises � main",
        Type: "COOKED ",
        Item_cost: 170
    },
    {
        Item_id: "MVT",
        Item_name: "Maharaja Veg Thali",
        IMG: "https://www.shoutlo.com/uploads/articles/header-img-sizzling-thalis-in-ludhiana-under-300.jpg",
        Discription: "In a Veg Maharaja thali, we serve butter chapati, paneer kadhai, mix veg, dal fry, pulao, sweet, veg raita, papad, and salad & pickle.",
        Type: "COOKED ",
        Item_cost: 200
    },
    {
        Item_id: "SNVT",
        Item_name: "Simple Non Veg Thali",
        IMG: "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto/nvnfvwesqiddtpeoe9jd",
        Discription: "In a Non Veg thali, we serve Rice with Fish curry, fish fry, and spiced buttermilk. fish � medium size Onions.",
        Type: "COOKED ",
        Item_cost: 250
    },
    {
        Item_id: "MNVT",
        Item_name: "Maharaja Non Veg Thali",
        IMG: "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto/nvnfvwesqiddtpeoe9jd",
        Discription: "In a Maharaja Non Veg thali. we serve 1. MUTTON SUKHA ",
        Type: "COOKED ",
        Item_cost: 350
    },
    {
        Item_id: "VSD",
        Item_name: "Veg Sandwich",
        IMG: "https://static.toiimg.com/thumb/83740315.cms?imgsize=361903&width=800&height=800",
        Discription: "This sandwich includes beetroots, tomatoes, cucumbers, potatoes and onions. I add equal amounts of each veggie to this sandwich.",
        Type: "Fast Food ",
        Item_cost: 80
    },
    {
        Item_id: "VSUP",
        Item_name: "Veg Soup",
        IMG: "https://hebbarskitchen.com/wp-content/uploads/2019/12/vegetable-soup-recipe-mix-veg-soup-recipe-mixed-vegetable-soup-1-768x1152.jpeg",
        Discription: "This vegetable soup uses veggies like carrots, peas, sweet corn, green beans and cabbage. It is flavored with ginger and garlic.",
        Type: "Fast Food ",
        Item_cost: 100
    },
    {
        Item_id: "NVSUP",
        Item_name: "Non Veg Soup",
        IMG: "https://im.rediff.com/getahead/2016/jan/13paya-soup.jpg",
        Discription: "chicken Sweet Corn Soup. It is one of the most common and tastiest soups we mostly find at restaurants.",
        Type: "Fast Food ",
        Item_cost: 200
    },
    {
        Item_id: "PRS",
        Item_name: "Paracetamol tablet",
        IMG: "https://5.imimg.com/data5/SELLER/Default/2022/9/IV/UY/CG/75459511/500mg-paracetamol-tablet-500x500.jpg",
        Discription: "Paracetamol is a commonly used medicine that can help treat pain and reduce a high temperature (fever).",
        Type: "MEDS ",
        Item_cost: 10
    }
]
export default meals;